<script setup lang="ts">
  interface Emits {
    (event: "update:isChecked", isChecked: boolean): void;
  }
  interface Props {
    isChecked: boolean;
    label?: string;
  }
  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();
  const computedData = computed<boolean>({
    get: () => props.isChecked,
    set: value => {
      emit("update:isChecked", value);
    },
  });
</script>

<template>
  <div class="consent-checkbox d-flex align-center">
    <input id="consent-check" v-model="computedData" type="checkbox" />
    <label v-if="label" for="consent-check" class="consent-check-text cursor-pointer">
      {{ label }}
    </label>
  </div>
</template>

<style lang="scss" scoped>
  .consent-checkbox {
    input[type="checkbox"] {
      margin: 0;
      padding: 0;
      background: none;
      border: none;
      border-radius: 0;
      outline: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      width: 28px; /*チェックボックスの横幅*/
      height: 28px; /*チェックボックスの縦幅*/
    }

    input[type="checkbox"] {
      cursor: pointer;
      padding-left: 35px;
      vertical-align: middle;
      position: relative;
    }

    input[type="checkbox"]::before,
    input[type="checkbox"]::after {
      content: "";
      display: block;
      position: absolute;
    }

    input[type="checkbox"]::before {
      background-color: #666666;
      border-radius: 4px;
      width: 28px; /*チェックボックスの横幅*/
      height: 28px; /*チェックボックスの縦幅*/
      top: 2px;
      left: -2px;
    }

    input[type="checkbox"]::after {
      border-bottom: 2px solid #119cf6; /*チェックの太さ*/
      border-left: 2px solid #119cf6; /*チェックの太さ*/
      opacity: 0; /*チェック前は非表示*/
      height: 10px; /*チェックの高さ*/
      width: 18px; /*チェックの横幅*/
      transform: rotate(-45deg);
      top: 8px; /*チェック時の位置調整*/
      left: 3px; /*チェック時の位置調整*/
    }

    input[type="checkbox"]:checked::after {
      opacity: 1;
    }

    .consent-check-text {
      font-size: 14px;
    }
  }
</style>
